import React from "react";
import AnyQuestions from "../../reusable/AnyQuestions";
import { Link } from "react-router-dom";
import BillingAddress from "./BillingAddress";
import ShipingMethod from "./ShipingMethod";
import PaymentMethod from "./PaymentMethod";
import ConfirmOrder from "./ConfirmOrder";
import moment from "moment";
import ShippingAddress from "./ShippingAddress";
class CheckoutMain extends React.Component {

  render() {
    let { cart, product } = this.props;
    const { router } = this.props;
    //const total = (typeof this.props.apply_discount !== "undefined" && this.props.apply_discount !== null && typeof this.props.apply_discount.flatTotal !== "undefined" && typeof this.props.apply_discount.flatTotal.grandTotal !== "undefined") ? this.props.apply_discount.flatTotal.grandTotal : this.props.cart.total;
    let total = (typeof this.props.apply_discount.flatTotal !== "undefined" && typeof this.props.apply_discount.flatTotal.grandTotal !== "undefined") ? this.props.apply_discount.flatTotal.grandTotal + this.props.cart.shippingFee : this.props.cart.total;
    let subtotal = (typeof this.props.apply_discount.flatTotal !== "undefined" && typeof this.props.apply_discount.flatTotal.grandTotal !== "undefined") ? this.props.apply_discount.flatTotal.grandTotal : this.props.cart.subtotal;

    // for confirmation page
    if (this.props.orderPayload !== "undefined" && this.props.orderPayload.total) {
      cart = this.props.orderPayload.cart;
      product = this.props.orderPayload.product;
      if (typeof this.props.orderPayload.after_discount_totals_flat !== "undefined" && this.props.orderPayload.after_discount_totals_flat != null && this.props.orderPayload.after_discount_totals_flat.grandTotal) {
        total = this.props.orderPayload.paypal.transactions[0].amount.total;
      } else {
        total = this.props.orderPayload.total;
      }
    }

    if (total != null) {
      total = parseFloat(total).toFixed(2);
    }
    if (subtotal != null) {
      subtotal = parseFloat(subtotal).toFixed(2);
    }

    console.log("props", this.props);
    return (
        <section>
          <div className="container">
            <div className="row">
              <div className="col-md-4 cart-product-img">
                <img src="/images/mightywifi-product.png" alt="" />
                {/* <img src={this.props.product.image} alt="" /> */}
                {/* <div>
                  <img src="/images/divider.png" alt="" className="img-fluid" />
                </div> */}
                <h2 className="cart-product-title">{product.name}</h2>
                {
                  (cart.cartType === 'device_recharge') ? (
                      <strong>{(cart.useType === "GLOBAL" && typeof cart.country !== "undefined" && cart.country !== null) ? cart.country.name + " " + cart.recurring_profile.name : cart.useType + " " + cart.recurring_profile.name}</strong>
                  ) : (<strong>{product.shortDescription}</strong>)
                }

                <br/>

                {cart.cartType === 'sim' && (this.props.data.step2 || this.props.data.step4) ?
                    (
                        <div>
                          <p className="mb-0" style={{color:'#0076be',fontWeight:'900'}}>Taxes and Fees {!cart.tax && "Included"}</p>
                          <p className="mb-0" style={{color:'#0076be',fontWeight:'900'}}> {cart.shippingFee ? ("Shipping : " + cart.shippingFee.toFixed(2)) : null } {!cart.shippingFee && "Free Shipping"}</p>
                        </div>
                    ) : null
                }

                {
                  (typeof this.props.apply_discount !== "undefined" && this.props.apply_discount !== null && typeof this.props.apply_discount.flatTotal !== "undefined" && typeof this.props.apply_discount.flatTotal.grandTotal !== "undefined" && typeof this.props.apply_discount.value !== "undefined" && this.props.apply_discount.value > 0) ? (
                          <span>
                        {cart.cartType === 'device_recharge' ?
                            (<h4 className="text-custom mt-2 bold600 SansSerif" style={{textDecoration: "line-through"}}>${cart.total.toFixed(2)}</h4>)
                            : null
                        }

                            {cart.cartType === 'sim' ?
                                (<h4 className="text-custom mt-2 bold600 SansSerif" style={{textDecoration: "line-through"}}>${cart.total.toFixed(2)}</h4>)
                                : null
                            }

                            {/*{this.props.cart.cartType === 'recharge' ?
                            (<h1 className="text-custom mb-0 font-weight-normal" style={{textDecoration: "line-through"}}>${this.props.cart.total}</h1>)
                            : null
                        }*/}
                      </span>
                      )
                      : null
                }


                {cart.cartType === 'sim' ?
                    (<h4 className="text-custom mt-2 bold600 SansSerif"><span className="bold100">Total:</span> ${total}</h4>)
                    : null
                }

                {cart.cartType === 'device_recharge' ?
                    (<h4 className="text-custom mt-2 bold600 SansSerif"><span className="bold100">Total:</span> ${total}</h4>)
                    : null
                }

                {/*{cart.cartType === 'recharge' ?
                    (<h1 className="text-custom mb-0 font-weight-normal">Total: ${total}</h1>)
                    : null
                }*/}

                { (this.props.data.step2 || this.props.data.step3 || this.props.data.step4) ?
                    (
                        <div>
                          <p className="mb-0 cart-shipping-notie">+ Taxes and Fees</p>
                        </div>
                    ) : null
                }

                {
                  (typeof this.props.apply_discount !== "undefined" && this.props.apply_discount !== null && typeof this.props.apply_discount.type !== "undefined" && this.props.apply_discount.type === "powerbank") ? (
                          <div style={{margin: "20px 0 0 0"}}>
                            <h5 className="text-custom mb-0 font-weight-normal">Powerbank 1 EA included</h5>
                          </div>
                      )
                      : null
                }

              </div>

              {this.props.data.step2 ? (
                  <BillingAddress
                      handleBilling={this.props.handleBilling}
                      back={this.props.backStep1}
                      auth={this.props.auth}
                  />
              ) : null}

              {this.props.data.step4 ? (
                  <PaymentMethod
                      back={this.props.backStep3}
                      handlePayment={this.props.handlePayment}
                      setpaymentMode={this.props.setpaymentMode}
                      handlePaypalPayment={this.props.handlePaypalPayment}
                      calculateTax={this.props.calculateTax}
                      cart={this.props.cart}
                      isAddressFilled={this.props.isAddressFilled}
                      isProcessing={this.props.isProcessing}
                      validateDiscount = {this.props.validateDiscount}
                      setDiscountCode = {this.setDiscountCode}
                      discountDetails={this.props.apply_discount}
                      total={total}
                      subtotal={subtotal}
                      validate_discount_error={this.props.validate_discount_error}
                      recaptchaRef={this.props.recaptchaRef}
                      isHuman={this.props.isHuman}
                      humanKey={this.props.humanKey}
                      verifyCaptcha={this.props.verifyCaptcha}
                      expireCaptcha={this.props.expireCaptcha}
                  />
              ) : null}
              {this.props.data.step5 ? (
                  <ConfirmOrder product={{...this.props.product}} orderPayload={this.props.orderPayload} cart={this.props.cart}/>
              ) : null}
            </div>
          </div>
        </section>
    );
  }
}

export default CheckoutMain;



// WEBPACK FOOTER //
// ./src/pages/rechargeCheckout/CheckoutMain.js